var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCloud02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 23.3333L19.9998 20M19.9998 20L23.3332 23.3333M19.9998 20V27.5M26.6665 23.9524C27.6844 23.1117 28.3332 21.8399 28.3332 20.4167C28.3332 17.8854 26.2811 15.8333 23.7498 15.8333C23.5677 15.8333 23.3974 15.7383 23.3049 15.5814C22.2182 13.7374 20.2119 12.5 17.9165 12.5C14.4647 12.5 11.6665 15.2982 11.6665 18.75C11.6665 20.4718 12.3627 22.0309 13.489 23.1613",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud02);
export default __webpack_public_path__ + "static/media/upload-cloud-02.2fdd6860efde0db57c97b3639dc2ccf9.svg";
export { ForwardRef as ReactComponent };